module.exports = __webpack_public_path__ + "static/media/wordle_speed_live.468016b0.png";